<div class="rules-wrapper" *ngIf="description else noData">
    <!-- <div class="rules-content" [innerHTML]="description"></div> -->
    <div class="rules-content">
        <h3 i18n>Mission rules:</h3>
        <h5 i18n>All rules you need to know about Missions:</h5>
        <p [innerHTML]="description"></p>
    </div>
</div>
<ng-template #noData>
    <p i18n class="no-data">The missions has not started yet.</p>
</ng-template>
